<template>
    <MainContent title="Añadir compradores permitidos">
        <template v-slot:header>
            <h3 class="card-title pb-3">Añadir compradores</h3>
        </template>
        <template v-slot:content>
            <b-row v-if="!loading">
                <b-col cols="12">
                    <FormComprador :loading="loading" @terminado="addCompradores"/>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComprador from '@/components/backend/eventos/sesiones/compradores-permitidos/FormComprador';

    export default {    
        data() {
            return {
                loading: false
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.addCompradores();
                }
            },
            addCompradores(emails) {
                this.loading = true;

                const params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    emails: emails
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.compradores-permitidos.add'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.events.sesion.compradores-permitidos', params: { evento_id: this.evento_id, sesion_id: this.sesion_id } });
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            evento_id() {
                return this.$route.params.evento_id;
            },
            sesion_id() {
                return this.$route.params.sesion_id;
            }
        },
        components: {
            MainContent, FormComprador
        }
    }
</script>
